import api from 'api/instance';
import { QAItem } from 'components/modules/AddQALogModal/AddQALogModal.props';
import { FetchQueryType, FetchResponse } from 'types/common';
import { QALog } from 'types/QALog';
import { toApiPayloadDateFormat } from 'utils/dateUtils';

const URL = `${process.env.REACT_APP_API_URL}`;

type BaseQALogPayload = {
  employee: string;
  date: string;
  hours: number;
  items: QAItem[];
  notes?: string;
};

type CreateQALogPayload = BaseQALogPayload;

type UpdateQALogPayload = BaseQALogPayload & {
  _id: string;
};

export const createQALog = async (payload: CreateQALogPayload) => {
  const { data } = await api.post(`${URL}/qa-log`, payload);

  return data;
};

export const updateQALog = async (payload: UpdateQALogPayload) => {
  const { _id, ..._payload } = payload;
  const { data } = await api.patch(`${URL}/qa-log/${_id}`, _payload);

  return data;
};

export const deleteQALog = async (id: string | undefined) => {
  const { data } = await api.delete(`${URL}/qa-log/${id}`);

  return data;
};

export const fetchQALog = async (
  params: FetchQueryType & {
    sort?: number;
    endDate?: Date;
    startDate?: Date;
    employees?: string[];
    roles?: string[] | undefined;
    washHub: string;
  },
) => {
  const endDate = toApiPayloadDateFormat(params.endDate || '');
  const startDate = toApiPayloadDateFormat(params.startDate || '');

  const payload = {
    ...params,
    startDate,
    endDate,
  };

  const filteredParams = Object.fromEntries(
    Object.entries(payload).filter(
      ([_, value]) => value != null && value !== '',
    ),
  );

  const { data } = await api.get<FetchResponse<QALog>>(`${URL}/qa-log/list`, {
    params: filteredParams,
  });

  return data;
};

export const exportQALogCsv = async (payload: {
  washHub: string;
  startDate?: Date;
  endDate?: Date;
  roles?: string[] | undefined;
  employees?: string[] | undefined;
}) => {
  const { data } = await api.post<any>(`${URL}/qa-log/export-qalogs`, payload);

  return data;
};
